import "./App.css";
import Portada from "./components/portada/portada";
import Description from "./components/description/description";

function App() {
  return (
    <>
      <Portada />
      <Description />
    </>
  );
}

export default App;
